<template>
  <v-container fluid>
    <ValidationObserver ref="obs" v-slot="{ invalid }">
      <v-card
        class="d-flex justify-center flex-column mx-auto my-6 flat"
        width="1200"
        color="#fff"
      >
        <v-card-title class="d-flex justify-center pa-0 mt-6">
          依頼登録
        </v-card-title>
        <ValidationProvider name="タイトル" rules="required|max:50" v-slot="{ errors }">
          <div class="mx-10 mt-0">
            <v-text-field
            v-model="title"
            label="タイトル"
            placeholder=""
            outlined
            dense
            hide-details="auto"
            ></v-text-field>
          </div>
          <p class="error">{{ errors[0] }}</p>
        </ValidationProvider>
        <ValidationProvider name="本文" rules="required|max:3000" v-slot="{ errors }">
          <div class="mx-10 mt-0">
            <v-textarea
              v-model="body"
              label="本文"
              placeholder=""
              outlined
              dense
              hide-details="auto"
            ></v-textarea>
          </div> 
          <p class="error">{{ errors[0] }}</p>
        </ValidationProvider>
        <v-card-text justify="center">
          <dashboard :uppy="uppy" :props="{
              theme: 'light',
              inline: true,
              width: 3000,
              height: 350,
              disableThumbnailGenerator:true,
              showRemoveButtonAfterComplete:true,
              proudlyDisplayPoweredByUppy:false,
            }" />
            ※添付ファイルは(容量：50MB、個数：10)が上限となっております
        </v-card-text>
        <v-card-actions>
          <v-btn color="accent" class="ml-auto mt-0 black--text" @click="saveSupportRequest" :disabled="invalid" width="45%">登録</v-btn>
        </v-card-actions>  
      </v-card>
    </ValidationObserver>
  </v-container>
</template>

<script>
//import Enumerable from "linq";
import { Dashboard } from '@uppy/vue'
import Uppy from '@uppy/core'
import '@uppy/core/dist/style.css'
import '@uppy/dashboard/dist/style.css'
import ja_JP from '../../plugins/puppy_lang'
import FirebaseCloudStorage from "../../plugins/FirebaseCloudStorage";
import { getStorage } from "firebase/storage";
//import { format } from 'date-fns';
//import { ja } from 'date-fns/locale';

import { httpsCallable, getFunctions } from "firebase/functions";

export default {
  props: [
    'paramTitle',
    'paramBody'
  ],
  // ファイルアップロード実装 START-------------------------
  components: {
    Dashboard
  },
  computed: {
    uppy() {
      const storage = getStorage(this.$firebase);
      const storagePath = this.$root.uploadPath;
      var uppy = new Uppy()
      .use(FirebaseCloudStorage, { storage, storagePath });
      return uppy;
    },
  },
  mounted() {
    this.uppy.on('upload', () => {
      this.$root.loading = true;
    });
    this.uppy.on('upload-success', (file) => {
      // 配列にファイルを追加
      this.fileList.add(file.meta.refId);
    });
    this.uppy.on('complete', () => {
      this.$root.loading = false;
    });
    this.uppy.on('file-removed', (file) => {
      // 配列からファイルを削除
      this.fileList.delete(file.meta.refId);
    });
    // 50MB制限+10ファイル制限
    this.uppy.setOptions({
      debug: true,
      locale: ja_JP,
      autoProceed: true,
      restrictions: {
        maxFileSize: (50 * 1024 * 1024),
        maxNumberOfFiles: 10,
      },
    });
  },
  beforeDestroy () {
    this.uppy.close({ reason: 'unmount' })
  },
  // ファイルアップロード実装 END-------------------------
  data() {
    return {
      title: "",
      body: "",
      fileList: new Set(),
    };
  },
  async created() {
    if(this.paramTitle)this.title = this.paramTitle;
    if(this.paramBody)this.body = this.paramBody;
  },
  methods: {
    // 保守依頼登録
    async saveSupportRequestRegist() {
      if(!this.selectGroupId){
        alert("グループ指定がありません。");
        return;
      }
      // ローディング表示
      this.$root.loading = true;
      const functions = getFunctions(this.$firebase);
      functions.region = "asia-northeast1";
      const schoolAidSupportLogined = httpsCallable(functions,"schoolAidSupportLogined");
      var data = {
        funcName: "saveSupportRequestRegist",
        title : this.title,
        body : this.body,
        fileList : Array.from(this.fileList),
      };
      await schoolAidSupportLogined(data).then((res) => {
        // ローディング非表示
        this.$root.loading = false;
        console.log(res.data);
        if (res.data == "success"){
          alert("登録しました。");
          this.$router.push({
            name: "CustomerTopPage",
          });
        } else {
          alert(res.data);
        }
      });
    },
  },
};
</script>